var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 11C12.6629 11 15.125 8.53789 15.125 5.5C15.125 2.46211 12.6629 0 9.625 0C6.58711 0 4.125 2.46211 4.125 5.5C4.125 8.53789 6.58711 11 9.625 11ZM13.475 12.375H12.7574C11.8035 12.8133 10.7422 13.0625 9.625 13.0625C8.50781 13.0625 7.45078 12.8133 6.49258 12.375H5.775C2.58672 12.375 0 14.9617 0 18.15V19.9375C0 21.0762 0.923828 22 2.0625 22H17.1875C18.3262 22 19.25 21.0762 19.25 19.9375V18.15C19.25 14.9617 16.6633 12.375 13.475 12.375Z",
    fill: "#204FB0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBlue);
export default __webpack_public_path__ + "static/media/userBlue.fe52efc74ce7b7d0427fe05fd33a802f.svg";
export { ForwardRef as ReactComponent };